module.exports = {
  //SERVER_URL: "http://10.10.10.141:8080",
     SERVER_URL: "https://api.rx-apa.ca",

  // SERVER_URL:
  //   process.env.NODE_ENV === "development"
  //     ? "http://localhost:80"
  //     : "http://54.175.230.220",
  DRAG_TYPE_SEANCE: "application/x-seance",

};
